import { render, staticRenderFns } from "./UserStatistics.vue?vue&type=template&id=570835a2&scoped=true"
import script from "./UserStatistics.vue?vue&type=script&lang=js"
export * from "./UserStatistics.vue?vue&type=script&lang=js"
import style0 from "./UserStatistics.vue?vue&type=style&index=0&id=570835a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570835a2",
  null
  
)

export default component.exports